import React, { useState } from 'react';
import 'twin.macro';
import { Button } from '../button';
import { Input } from './FormParticals';
import { Icon } from '../icon';
import { LoaderIcon } from 'icons';
import { submitTipForm } from 'services/user';
import { Notification } from '../notifications';
export const SUBMIT_TIPFORM_SUCCESS_MESSAGE = 'Je tip is verzonden, bedankt!';
export const SUBMIT_TIPFORM_ERROR_MESSAGE = 'Er gaat iets fout... probeer het nog eens';

export const TipForm = () => {
  const [link, setLink] = useState('');
  const [extra, setExtra] = useState('');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState({});

  const submit = (e) => {
    e.preventDefault();
    setLoading(true);
    setNotification({});

    submitTipForm({
      email,
      link,
      description: extra,
    })
      .then(() => {
        setEmail('');
        setLink('');
        setExtra('');
        setLoading(false);
        setNotification({ state: 'success', message: SUBMIT_TIPFORM_SUCCESS_MESSAGE });
      })
      .catch(() => {
        setLoading(false);
        setNotification({ state: 'error', message: SUBMIT_TIPFORM_ERROR_MESSAGE });
      });
  };

  return (
    <>
      {notification.state && (
        <Notification
          message={notification.message}
          style={notification.state}
          onClick={() => setNotification({})}
          tw='mb-4'
        />
      )}
      <form onSubmit={submit}>
        <Input
          placeholder='Link'
          name='link'
          id='link'
          value={link}
          onChange={(e) => setLink(e.target.value)}
          autoComplete='off'
          requiredField
          label={link ? 'Link' : ''}
        />
        <Input
          placeholder='Extra omschrijving of tijdstip'
          name='extra'
          id='extra'
          value={extra}
          onChange={(e) => setExtra(e.target.value)}
          label={extra ? 'Extra omschrijving' : ''}
        />
        <Input
          placeholder='E-mail'
          name='email'
          id='email'
          type='email'
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoComplete='email'
          requiredField
          label={email ? 'E-mail' : ''}
        />
        <div tw='flex justify-end'>
          <Button
            type='submit'
            label={
              !loading ? (
                'Verstuur tip'
              ) : (
                <Icon Type={LoaderIcon} tw='animate-spin h-5' color='input-back' size='small' />
              )
            }
            primary
            disabled={loading}
          />
        </div>
      </form>
    </>
  );
};
